import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import UserContext from '../context/UserContext';
import { 
    Grid,
    Button,
    Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    formControl: {
        minWidth: 120
    },
    selectFields: {
        minWidth: '450px',
        maxWidth: '450px'
    },
    main: {
        height: '300px'
    }

}));

export default function Action(props) {
    const classes = useStyles();
    const userContext = useContext(UserContext);

    useEffect(() => {
        async function getData(){
        }
        if (userContext.tenant){
            getData();
        }
    }, [userContext.tenant]);

    const handleAnswer = (answer) => () => {
        if (answer) {
            props.handleNext(2)
        } else {
            props.handleNext(3);
        }
    }

    return (
        <UserContext.Consumer>
            {({ tenant }) => (
                <div className={classes.main}>
                    <Grid item container direction="column">
                        <Grid item>
                            <Typography variant="h6">Are you a Global Admin for your Dynamics 365 organization?</Typography>
                        </Grid>
                        <br></br>
                        <Grid item container direction="row" spacing={2}>
                            <Grid item>
                                <Button color="primary" variant="contained" onClick={handleAnswer(true)}>Yes</Button>
                            </Grid>
                            <Grid item>
                                <Button color="primary" variant="outlined" onClick={handleAnswer(false)}>No</Button>
                            </Grid>
                        </Grid>
                        <Button></Button>
                    </Grid>
                </div>
            )}
        </UserContext.Consumer>
    );
}